import React, { useContext } from "react";
import AsyncSelect from "react-select/async";
import { useTranslation } from "react-i18next";
import { Controller } from "react-hook-form";
import { globalServices } from "../../../../../Services/global.service";
import { AuthContext } from "../../../../../Contexts/AuthContext";
import { roles } from "../../../../../Config/Roles";

const ClientInput = ({
  control,
  errors,
  setValue,
  setValues,
  setStores,
  setProducts,
}) => {
  const { t: translator } = useTranslation();
  const { userId, roleId } = useContext(AuthContext);

  const promiseOptions = (inputValue) => {
    return globalServices
      .getTenantsRobno(
        Number(localStorage.getItem("tenantId")) > 0 ? userId : null,
        inputValue,
      )
      .then((res) => {
        var result = res.data.map((e) => ({
          id: e.id,
          label: e.name,
          value: e.id,
        }));

        if (Number(roleId) === roles.owner && result.length === 1) {
          const tenantId =
            Number(localStorage.getItem("tenantId")) > 0
              ? Number(localStorage.getItem("tenantId"))
              : 0;
          const tenant = result.find((x) => x.id === tenantId) || null;
          setValue("tenantId", tenant);
          handleOnChangeTenantId(tenant ? [tenant] : null);
        }

        return result;
      })
      .catch((err) => err);
  };

  const handleOnChangeTenantId = (event) => {
    if (!event) return;

    setProducts([]);
    setValue("storeId", null, {
      shouldValidate: true,
    });
    if (event?.[1]?.action === "clear") {
      setStores([]);
      setValues({
        storeId: 0,
        tenantId: 0,
        priceListId: 0,
      });
    } else {
      globalServices
        .getStoresByTenantId(event[0].id)
        .then((res) => {
          setStores(res.data);
        })
        .catch((err) => console.log(err));
    }
    return event[0];
  };

  return (
    <div className="form-group">
      <label>{translator("EditPOS-Tenant")}</label>{" "}
      <Controller
        as={AsyncSelect}
        control={control}
        name="tenantId"
        onChange={handleOnChangeTenantId}
        placeholder={translator("Select-Tenant")}
        isClearable
        defaultOptions={true}
        loadOptions={promiseOptions}
        rules={{
          validate: function (value) {
            if (!value) return false;
            return value.value === 0 ? false : true;
          },
        }}
      />
      {errors.tenantId && errors.tenantId.type === "validate" && (
        <p className="text-danger">
          {translator("ValidationMsg-RequiredField")}
        </p>
      )}
    </div>
  );
};

export default ClientInput;
